import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//const baseUrl = "http://localhost:9000";
const baseUrl = "https://communityoflearning.accenture.com/communityoflearning-apis";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: token,
    },
  };
};

export const fetchMetrics = createAsyncThunk(
  "metrics/fetchMetrics",
  async (_, { rejectWithValue }) => {
    try {

      const response = await axios.get(
        `${baseUrl}/metrics`,
        getAuthHeader()
      );

      return response.data;

    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch metrics"
      );
    }
  }
);

const metricsSlice = createSlice({
  name: "metrics",

  initialState: {
    metrics: null,
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.metrics = action.payload;
      })

      .addCase(fetchMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export default metricsSlice.reducer;